import { render } from "./LogsList.vue?vue&type=template&id=30b66c11"
import script from "./LogsList.vue?vue&type=script&lang=js"
export * from "./LogsList.vue?vue&type=script&lang=js"

import "./LogsList.vue?vue&type=style&index=0&id=30b66c11&lang=scss"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__